function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useState, useMemo, useCallback, memo } from 'react';
import { useIntl } from 'react-intl';
import styled, { keyframes, css } from 'styled-components';
import { durations, curves } from '@cbhq/cds-common/motion/tokens';
import { Button } from '@cbhq/cds-web/buttons/Button';
import { Icon } from '@cbhq/cds-web/icons';
import { VStack, HStack, Divider, Box } from '@cbhq/cds-web/layout';
import { deviceBreakpoints } from '@cbhq/cds-web/layout/breakpoints';
import { Pressable } from '@cbhq/cds-web/system';
import { TextBody, TextHeadline, TextLabel1, TextLabel2 } from '@cbhq/cds-web/typography';
import { ActionType, ComponentType } from '@cbhq/client-analytics';
import ChevronRight from '../../../assets/icons/ChevronRight.js';
import getCoinbaseLocalizedUrl from '../../../utils/getCoinbaseLocalizedUrl.js';
import globalNavLogEvent from '../../../utils/globalNavLogEvent.js';
import useMainCTACopy from '../../../utils/useMainCTACopy/useMainCTACopy.js';
import useSecondaryCTACopy from '../../../utils/useSecondaryCTACopy/useSecondaryCTACopy.js';
import { GLOBAL_EDITION_CODE } from '../../GlobalPreferences/constants.js';
import { useDisplayDetails } from '../../GlobalPreferences/hooks/useDisplayDetails.js';
import { isGlobalEdition } from '../../GlobalPreferences/utils/isGlobalEdition.js';
import LanguageSelectorDrawer from '../../LanguageSelector/LanguageSelectorDrawer.js';
import '../../Link/index.js';
import GlobalNavContext from '../context/GlobalNavContext.js';
import MobileLanguageCountrySelector from '../LanguageCountrySelectorModal/MobileLanguageCountrySelector.js';
import { ColumnHeaderLink } from '../MainNav/Trapdoor/styles.js';
import '../MainNav/Trapdoor/TrapdoorContent/index.js';
import messages from '../messages.js';
import { NavBody } from '../NavTypography.js';
import SublinkIcon from '../SublinkIcon.js';
import { MENU_PADDING } from './constants.js';
import MobileMenuItem, { ItemWrapper } from './MobileMenuItem.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { TRAPDOOR_MESSAGES_MAP } from '../MainNav/Trapdoor/TrapdoorContent/TrapdoorContent.js';
import Link from '../../Link/Link.js';
function hasActiveTabMessage(key) {
  return key in TRAPDOOR_MESSAGES_MAP;
}
function MobileNav({
  navLinks,
  activeTab,
  setSelectedTab,
  mainCTA,
  secondaryCTA,
  isOpen,
  isInRewardsHubExperiment,
  localeInformation,
  userLocaleInfo
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const _useContext = useContext(GlobalNavContext),
    signInUrl = _useContext.signInUrl,
    signUpUrl = _useContext.signUpUrl,
    onClickSignIn = _useContext.onClickSignIn,
    onClickSignUp = _useContext.onClickSignUp,
    showSignInButton = _useContext.showSignInButton,
    showSignUpButton = _useContext.showSignUpButton,
    showGetStartedButtonOnMobile = _useContext.showGetStartedButtonOnMobile,
    localeCode = _useContext.localeCode,
    isGlobalPreferencesEnabled = _useContext.isGlobalPreferencesEnabled,
    localeFromUrl = _useContext.localeFromUrl;
  const activeNavLink = navLinks.find(navLink => navLink.key === activeTab);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showSubmenu = _useState2[0],
    setShowSubmenu = _useState2[1];
  const handleClickTab = tabKey => {
    setSelectedTab(tabKey);
    openSubmenu();
  };

  // TODO: @gokul-kathirvel This is just to merge the changes in master with the new picker.
  // Once the new picker is enabled, this will be cleaned up.
  const countryCodeForGlobalPreferenceDetails = useMemo(() => {
    const countryFromIp = userLocaleInfo.countryFromIp,
      countryFromUrl = userLocaleInfo.countryFromUrl,
      languageCode = userLocaleInfo.languageCode;
    const countryCode = isGlobalEdition({
      countryFromUrl,
      languageCode,
      countryFromIp,
      localeFromUrl
    }) ? GLOBAL_EDITION_CODE : countryFromUrl;
    return countryCode ?? '';
  }, [userLocaleInfo, localeFromUrl]);
  const _useDisplayDetails = useDisplayDetails(countryCodeForGlobalPreferenceDetails, userLocaleInfo?.languageCode || '', localeInformation.localeCodeToDisplayName, localeFromUrl),
    _useDisplayDetails$co = _useDisplayDetails.countryName,
    countryName = _useDisplayDetails$co === void 0 ? '' : _useDisplayDetails$co,
    _useDisplayDetails$la = _useDisplayDetails.languageName,
    languageName = _useDisplayDetails$la === void 0 ? '' : _useDisplayDetails$la;
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    canShowLanguageSelectorDrawer = _useState4[0],
    setLanguageSelectorDrawer = _useState4[1];
  const openLanguageSelectorDrawer = useCallback(() => {
    globalNavLogEvent('logged_out_nav_mobile_language_selector_open', {
      action: ActionType.click,
      componentType: ComponentType.button
    });
    setLanguageSelectorDrawer(true);
  }, []);
  const closeLanguageSelectorDrawer = useCallback(() => {
    setLanguageSelectorDrawer(false);
  }, []);
  const mainCTACopy = useMainCTACopy(mainCTA);
  const secondaryCTACopy = useSecondaryCTACopy(secondaryCTA);
  const localeCodeLabel = localeInformation.localeCodeToDisplayName[localeInformation.selectedLocaleCode];
  const languageSelectorAriaControls = {
    'aria-controls': 'global-nav-mobile-sublinks',
    role: 'button'
  };

  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop
  const handleLanguageSelectorKeyPress = event => {
    if (event.key === 'Enter') {
      // This handler is for old picker.
      // However, we are passing the screenId to be compatible.
      // Once the new picker is enabled, these methods will be cleaned up.
      openLanguageSelectorDrawer();
    }
  };
  const openSubmenu = useCallback(() => setShowSubmenu(true), []);
  const closeSubmenu = useCallback(() => {
    setSelectedTab(null);
    setShowSubmenu(false);
  }, [setSelectedTab]);
  const getColumns = useCallback(tab => {
    if (!tab) {
      return [];
    }
    const currentTab = navLinks.find(link => link.key === tab);
    if (!currentTab) {
      return [];
    }
    const columns = currentTab.subLinks?.map(column => {
      return _objectSpread(_objectSpread({}, column), {}, {
        links: column.links.filter(link => {
          if (!isInRewardsHubExperiment && tab === 'individuals') {
            return link.intlLabelKey !== 'rewardsHub';
          }
          return true;
        })
      });
    }) || [];
    return columns;
  }, [isInRewardsHubExperiment, navLinks]);
  const activeColumns = getColumns(activeTab);
  const activeNavMessages = activeTab && hasActiveTabMessage(activeTab) ? TRAPDOOR_MESSAGES_MAP[activeTab] : null;
  const isActiveTabCompany = activeTab === 'company';
  return /*#__PURE__*/jsxs(MenuWrapper, {
    id: "global-nav-mobile-dropdown",
    $isOpen: isOpen,
    children: [navLinks.map(item => {
      const itemLabel = formatMessage(messages[item.intlLabelKey]);
      const columns = getColumns(item.key);
      const hasSubLinks = columns?.some(column => column.links.length > 0);
      return /*#__PURE__*/jsx(React.Fragment, {
        children: /*#__PURE__*/jsxs(MobileMenuItem, {
          navLink: item
          // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop
          ,

          onClick: () => hasSubLinks && handleClickTab(item.key),
          activeTab: activeTab,
          children: [/*#__PURE__*/jsx(Icon, {
            name: item.iconName || 'coinbase',
            spacingEnd: 3,
            size: "s"
          }), /*#__PURE__*/jsx(LabelText, {
            children: itemLabel
          }), hasSubLinks && /*#__PURE__*/jsx(IconWrapper, {
            children: /*#__PURE__*/jsx(Icon, {
              name: "caretRight",
              size: "s",
              color: "foreground"
            })
          })]
        })
      }, item.key);
    }), /*#__PURE__*/jsxs(MobileMenuItem, {
      onClick: openLanguageSelectorDrawer,
      activeTab: activeTab,
      children: [/*#__PURE__*/jsx(Icon, {
        name: "globe",
        spacingEnd: 3,
        size: "s"
      }), /*#__PURE__*/jsxs(VStack, {
        children: [/*#__PURE__*/jsx(LabelText, {
          children: countryName
        }), /*#__PURE__*/jsx(TextBody, {
          as: "p",
          color: "foregroundMuted",
          children: languageName
        })]
      }), /*#__PURE__*/jsx(IconWrapper, {
        children: /*#__PURE__*/jsx(Icon, {
          name: "caretRight",
          size: "s",
          color: "foreground"
        })
      })]
    }), showSubmenu && /*#__PURE__*/jsx(MobileAnimationWrapper, {
      $isOpen: showSubmenu,
      children: /*#__PURE__*/jsxs(VStack, {
        width: "100%",
        height: "100%",
        children: [/*#__PURE__*/jsxs(HStack, {
          spacingHorizontal: 4,
          spacingVertical: 2,
          justifyContent: "space-between",
          alignItems: "center",
          children: [/*#__PURE__*/jsxs(HStack, {
            children: [/*#__PURE__*/jsx(Pressable, {
              background: "transparent",
              accessibilityLabel: "back button",
              onPress: closeSubmenu,
              children: /*#__PURE__*/jsx(Icon, {
                size: "s",
                name: "caretLeft",
                spacingEnd: 3,
                color: "foreground"
              })
            }), /*#__PURE__*/jsx(TextHeadline, {
              as: "p",
              children: activeNavLink?.name
            })]
          }), !!activeNavLink?.mobileNavbarLinkUrl && activeNavMessages?.mobileNavBarLinkText && /*#__PURE__*/jsx(Link, {
            to: activeNavLink?.mobileNavbarLinkUrl,
            children: /*#__PURE__*/jsx(TextHeadline, {
              as: "p",
              color: "primary",
              children: formatMessage(activeNavMessages.mobileNavBarLinkText)
            })
          })]
        }), /*#__PURE__*/jsx(Divider, {
          spacingTop: 1
        }), activeTab && activeNavMessages && /*#__PURE__*/jsx(VStack, {
          id: "global-nav-mobile-sublinks",
          spacingVertical: 1,
          spacingStart: isActiveTabCompany ? 1 : 0,
          children: activeColumns.map((column, index) => {
            const title = column.title,
              links = column.links;
            return /*#__PURE__*/jsxs(React.Fragment, {
              children: [title && /*#__PURE__*/jsx(Box, {
                alignItems: "center",
                height: 44,
                spacing: 2,
                children: title.url ? /*#__PURE__*/jsx(ColumnHeaderLink, {
                  $fullWidth: true,
                  to: title.notLocalized ? title.url : getCoinbaseLocalizedUrl(title.url, localeCode),
                  children: /*#__PURE__*/jsxs(HStack, {
                    gap: 1,
                    justifyContent: "space-between",
                    width: "100%",
                    children: [/*#__PURE__*/jsx(TextLabel1, {
                      as: "p",
                      children: formatMessage(activeNavMessages[title.intlKey])
                    }), /*#__PURE__*/jsx(Icon, {
                      name: "caretRight",
                      size: "s",
                      dangerouslySetColor: "inherit"
                    })]
                  })
                }) : /*#__PURE__*/jsx(TextLabel1, {
                  as: "p",
                  children: formatMessage(activeNavMessages[title.intlKey])
                })
              }), links.map(link => /*#__PURE__*/jsxs(SubLink, {
                to: link?.notLocalized ? link.url : getCoinbaseLocalizedUrl(link.url, localeCode),
                testID: `mobile-menu-sublink-${activeTab}-${link.intlLabelKey}`,
                children: [/*#__PURE__*/jsx(Box, {
                  spacingEnd: 3,
                  children: /*#__PURE__*/jsx(SublinkIcon, {
                    item: link
                  })
                }), /*#__PURE__*/jsxs(VStack, {
                  children: [/*#__PURE__*/jsx(TextLabel1, {
                    as: "p",
                    children: formatMessage(activeNavMessages[link.intlLabelKey])
                  }), /*#__PURE__*/jsx(TextLabel2, {
                    as: "p",
                    color: "foregroundMuted",
                    children: link.intlDescriptionKey && formatMessage(activeNavMessages[link.intlDescriptionKey])
                  })]
                })]
              }, link.intlLabelKey))]
            }, index);
          })
        })]
      })
    }), !showSubmenu && /*#__PURE__*/jsxs(ButtonWrapper, {
      children: [showSignUpButton && showGetStartedButtonOnMobile && /*#__PURE__*/jsx(Link, {
        to: signUpUrl,
        onClick: onClickSignUp,
        testID: "header-get-started-button",
        children: /*#__PURE__*/jsx(Button, {
          block: true,
          analyticsId: "5d711873-226c-46a1-a5ab-28ce1fc7b7c9",
          children: formatMessage(mainCTACopy || messages.signUpLink)
        })
      }), showSignInButton && /*#__PURE__*/jsx(Link, {
        to: signInUrl,
        onClick: onClickSignIn,
        testID: "header-sign-in-button",
        children: /*#__PURE__*/jsx(Button, {
          variant: "secondary",
          block: true,
          analyticsId: "e9e52a41-3405-426b-b4c2-8fb5458aeb7a",
          children: formatMessage(secondaryCTACopy || messages.signInLink)
        })
      })]
    }), isGlobalPreferencesEnabled ? canShowLanguageSelectorDrawer && /*#__PURE__*/jsx(MobileAnimationWrapper, {
      $isOpen: canShowLanguageSelectorDrawer,
      children: /*#__PURE__*/jsx(LanguageSelectorDrawer, {
        closeSubmenu: closeLanguageSelectorDrawer,
        localeInformation: localeInformation,
        userLocaleInfo: userLocaleInfo
      })
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsxs(ItemWrapper, _objectSpread(_objectSpread({
        onClick: openLanguageSelectorDrawer,
        onKeyDown: handleLanguageSelectorKeyPress,
        tabIndex: 0
      }, languageSelectorAriaControls), {}, {
        children: [/*#__PURE__*/jsx(Icon, {
          name: "globe",
          color: "foreground",
          size: "s",
          spacingEnd: 2
        }), /*#__PURE__*/jsx(LabelText, {
          children: localeCodeLabel
        }), /*#__PURE__*/jsx(ChevronRight, {})]
      })), canShowLanguageSelectorDrawer && /*#__PURE__*/jsx(MobileAnimationWrapper, {
        $isOpen: canShowLanguageSelectorDrawer,
        children: /*#__PURE__*/jsx(MobileLanguageCountrySelector, {
          localeInformation: localeInformation,
          closeLanguageSelector: closeLanguageSelectorDrawer
        })
      })]
    })]
  });
}
const MobileMenu = /*#__PURE__*/memo(MobileNav);
const SHOW_MOBILE_NAV_ANIMATION = keyframes`
  0% {
    transform: translateY(-750px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;
const SHOW_LANGUAGE_SELECTOR_ANIMATION = keyframes`
  0% {
    transform: translateX(750px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;
const MenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${({
  $isOpen
}) => $isOpen ? css`
          animation: ${SHOW_MOBILE_NAV_ANIMATION} ${durations.moderate3}ms
            cubic-bezier(${curves.global.join(',')});
          animation-fill-mode: forwards;
        ` : ''}
  padding-top: 5px;
  box-sizing: border-box;
  position: relative;
  width: 100%;
  flex: 1;
  overflow-y: auto;
  background: ${({
  theme
}) => theme.color.background};
  z-index: ${p => p.theme.zIndex.hidden};
`;
const MobileAnimationWrapper = styled.div`
  ${({
  $isOpen
}) => $isOpen ? css`
          animation: ${SHOW_LANGUAGE_SELECTOR_ANIMATION}
            ${durations.moderate3}ms cubic-bezier(${curves.global.join(',')});
          animation-fill-mode: forwards;
        ` : ''}
  top: 0px;
  padding-top: 5px;
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  bottom: 0px;
  overflow-y: auto;
  background: ${({
  theme
}) => theme.color.background};
`;
const IconWrapper = styled.span`
  margin-left: auto;
`;
const LabelText = styled(NavBody)`
  font-weight: 500;
  flex: 1;
`;
const ButtonWrapper = styled.div`
  padding: ${MENU_PADDING};
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow:
    0px 6px 10px 0px rgba(91, 97, 110, 0.14),
    0px 1px 18px 0px rgba(91, 97, 110, 0.12),
    0px 3px 5px 0px rgba(91, 97, 110, 0.2);
  margin-top: auto;

  @media screen and (min-width: ${deviceBreakpoints.tablet}px) {
    flex-direction: row;

    span {
      flex: 1;
      display: block;
      width: 100%;
      text-align: center;
    }

    a {
      flex: 1;
    }
  }
`;

/* eslint-disable @cbhq/theme-no-static-value */
// eslint isn't liking the colors here.
const SubLink = styled(Link)`
  display: flex;
  align-items: center;
  color: initial;
  padding: 16px 24px;
`;

/* eslint-enable */

export { MobileMenu as default };
//# sourceMappingURL=MobileMenu.js.map
